<template>
  <v-app>
    <v-app-bar app color="primary" dark class="justify-center">
      <v-toolbar-title>{{ appTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="isLoggedIn">
        <v-tooltip bottom color="grey lighten-5 black--text">
          <template v-slot:activator="{ on }">
        <v-btn text v-on="on" @click="doCopySysPhoneNumber">
          {{ sysPhoneNumber }}
        </v-btn>
          </template>
          <span>System SMS phone #</span>
        </v-tooltip>
        <v-tooltip bottom color="grey lighten-5 black--text">
          <template v-slot:activator="{ on }">
            <v-btn icon @click="doLogout" v-on="on">
              <v-icon>mdi-exit-to-app</v-icon>
            </v-btn>
          </template>
          <span>Logout</span>
        </v-tooltip>
      </div>
      <template v-if="isLoggedIn" v-slot:extension>
        <SendButton :show="isLoggedIn"></SendButton>
        <AddUserButton :show="isLoggedIn && showAddUserBtn"></AddUserButton>

        <v-tabs v-show="isLoggedIn" v-model="tab" :centered="$vuetify.breakpoint.smAndUp" :right="$vuetify.breakpoint.xsOnly">
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="item in items" :key="item.id" :to="item.to">
            {{ item.caption }}
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-content>
      <v-container fluid class="pt-4">
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-footer padless>
      <v-banner
        :value="!isServerAlive"
        tile
        icon="mdi-alert-circle-outline"
        icon-color="white"
        color="error"
        class="white--text"
        elevation="4"
        width="100%"
      >
        It seems like the server isn't responding right now. Most features
        will not work until the connection is restored.
        <template v-slot:actions>
          <v-btn
            text
            color="white"
            style="margin-top: 2px; margin-bottom: 2px;"
            @click="doRefresh"
            >Reload</v-btn>
        </template>
      </v-banner>
      <v-card flat tile width="100%" color="grey lighten-5" elevation="3">
        <v-card-text>
          <v-row dense no-gutters>
            <v-col cols="6">
              {{ appVersion }}
            </v-col>
            <v-col cols="6" class="text-right">
              &copy; {{ new Date().getFullYear() }}
              <a href="https://carsley.com" target="_blank">Carsley &amp; Associates</a>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-footer>
    <v-snackbar v-model="isSnackbarShown" :color="color">
      {{ message }}
      <v-btn text @click="dismissSnackbar">
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import SendButton from "@/components/SendButton";
import AddUserButton from "@/components/AddUserButton";
import { mapState, mapGetters, mapActions } from "vuex";
import { version } from "../lib/version";

export default {
  name: "App",

  components: {
    SendButton,
    AddUserButton,
  },
  data: () => ({
    showAddUserBtn: false,
    tab: null,
    items: [
      {
        id: "history",
        caption: "History",
        to: {
          name: "History",
        },
      },
      {
        id: "users",
        caption: "Users",
        to: {
          name: "Users",
        },
      },
      {
        id: "settings",
        caption: "Settings",
        to: {
          name: "Settings"
        }
      }
    ],
    heartbeatHandle: null,
  }),
  computed: {
    appTitle() {
      return `${process.env.VUE_APP_CUSTOMER_NAME} SMS Alerts`;
    },
    appVersion() {
      return `v${version}`;
    },
    sysPhoneNumber() {
      return process.env.VUE_APP_SYS_PHONE_NUMBER
    },
    isSnackbarShown: {
      get() {
        return this.hasSnackbar;
      },
      set(value) {
        if (!value) {
          this.dismissSnackbar();
        }
      },
    },
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapGetters("snackbar", ["hasSnackbar"]),
    ...mapState("snackbar", ["message", "color"]),
    ...mapState("status", ["isServerAlive"]),
  },
  watch: {
    $route(to) {
      this.showAddUserBtn = to.name === "Users" || to.name === "UserEdit";
    },
  },
  mounted() {
    this.doHeartbeatLoop();
  },
  methods: {
    doCopySysPhoneNumber() {
      this.$copyText(this.sysPhoneNumber)
    },
    doRefresh() {
      window.location.reload();
    },
    doHeartbeatLoop() {
      this.checkServerHeartbeat().then(() => {
        this.heartbeatHandle = setTimeout(this.doHeartbeatLoop, 15 * 1000);
      });
    },
    doLogout() {
      this.logout().then(() => {
        this.showSnackbar({ message: "You have been logged out." });
        this.$router.push({ name: "Login" });
      });
    },

    ...mapActions("auth", ["logout"]),
    ...mapActions("snackbar", ["showSnackbar", "dismissSnackbar"]),
    ...mapActions("status", ["checkServerHeartbeat"]),
  },
};
</script>

<style lang="scss" scoped>
.v-banner ::v-deep {
  .v-banner__wrapper {
    .v-banner__actions {
      margin-bottom: 0;
    }
  }
}
</style>
